<template safe-area-inset-top safe-area-inset-bottom>
  <div id="app">
    <router-view  v-if="!$route.meta.keepAlive"/>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>

    <van-tabbar v-if="showTabbar" v-model="active" route active-color="#1989fa" safe-area-inset-bottom>
      <template v-for="item in tabbarItems">
        <van-tabbar-item v-if="!item.custom" replace :to="item.url" :icon="item.icon">{{ item.name }}</van-tabbar-item>

        <van-tabbar-item v-else="!item.custom" replace :to="item.url">
          <span>{{ item.name }}</span>
          <template #icon="props">
            <img :src="item.getSrc(props)" />
          </template>
        </van-tabbar-item>
      </template>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      showTabbar: false,
      active: -1,
      tabbarItems: [
        {
          url: "/charter-order",
          name: "待包车",
          custom: true,
          getSrc: (props) => {
            return props.active
              ? require("@/assets/ic_bus_blue.png")
              : require("@/assets/ic_bus_gray.png");
          },
        },
        {
          url: "/charter-record",
          name: "包车记录",
          custom: false,
          icon: "search",
        },
        {
          url: "/mine",
          name: "我的",
          custom: false,
          icon: "contact-o",
        },
      ],
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        const tabRoutes = this.tabbarItems.map((item) => item.url);
        this.active = tabRoutes.indexOf(to.path);
        this.showTabbar = this.active > -1;
      },
    },
  },
};
</script>
<style></style>
